export const FAVORITE_CLIENT = 'CLIENTS/FAVORITE_CLIENT';
export const FAVORITE_CLIENT_SUCCESS = 'CLIENTS/FAVORITE_CLIENT_SUCCESS';
export const FAVORITE_CLIENT_ERROR = 'CLIENTS/FAVORITE_CLIENT_ERROR';
export const LOAD_CLIENTS = 'CLIENTS/LOAD_CLIENTS';
export const LOAD_CLIENTS_ERROR = 'CLIENTS/LOAD_CLIENTS_ERROR';
export const LOAD_CLIENTS_SUCCESS = 'CLIENTS/LOAD_CLIENTS_SUCCESS';
export const UPDATE_CLIENT = 'CLIENTS/UPDATE_CLIENT';
export const VERIFY_RISK_CLIENT = 'CLIENTS/VERIFY_RISK_CLIENT';
export const UPDATE_STATE_CLIENT = 'CLIENTS/UPDATE_STATE_CLIENT';
export const UPLOAD_CLIENTS = 'CLIENTS/UPLOAD_CLIENTS';
